import { createV5Theme, defaultChildrenThemes } from "@tamagui/config/v5";
import { v5ComponentThemes } from "@tamagui/themes/v5";
import { yellow, yellowDark, red, redDark } from "@tamagui/colors";
const lightPalette = ["#fcfcfd", "#f9f9fb", "#eff0f3", "#e7e8ec", "#e0e1e6", "#d8d9e0", "#cdced7", "#b9bbc6", "#8b8d98", "#80828d", "#62636c", "#1e1f24"];
const darkPalette = ["#111113", "#19191b", "#222325", "#292a2e", "#303136", "#393a40", "#46484f", "#5f606a", "#6c6e79", "#797b86", "#b2b3bd", "#eeeef0"];
const accentLight = {
  "accent1": "#fbfefc",
  // App background
  "accent2": "#f4fbf7",
  // Subtle background
  "accent3": "#e6f6ec",
  // UI element background
  "accent4": "#d6f0e0",
  // Hovered UI background
  "accent5": "#c5e8d2",
  // Active UI background
  "accent6": "#afddc0",
  // Subtle border
  "accent7": "#9ed2b2",
  // UI element border (interpolated)
  "accent8": "#91cda9",
  // Hovered UI border (interpolated)
  "accent9": "#85C19D",
  // BRAND COLOR (Solid Backgrounds)
  "accent10": "#77b38e",
  // Hovered Solid Background
  "accent11": "#2d6b47",
  // Low-contrast text
  "accent12": "#1e3a2a"
  // High-contrast text
};
const accentDark = {
  "accent1": "#0e1210",
  // App background
  "accent2": "#141a16",
  // Subtle background
  "accent3": "#1c2921",
  // UI element background
  "accent4": "#21372a",
  // Hovered UI background
  "accent5": "#2a4435",
  // Active UI background
  "accent6": "#355341",
  // Subtle border
  "accent7": "#41644f",
  // UI element border
  "accent8": "#4e785f",
  // Hovered UI border
  "accent9": "#85C19D",
  // BRAND COLOR (Solid Backgrounds)
  "accent10": "#96ccaa",
  // Hovered Solid Background (lighter for dark mode)
  "accent11": "#aee1c1",
  // Low-contrast text
  "accent12": "#ceefda"
  // High-contrast text
};
const builtThemes = createV5Theme({
  // Use the Grayscale arrays here
  lightPalette,
  darkPalette,
  componentThemes: v5ComponentThemes,
  // Use the Brand Accent arrays here
  accent: {
    light: accentLight,
    dark: accentDark
  },
  childrenThemes: {
    ...defaultChildrenThemes,
    warning: {
      light: yellow,
      // Assuming these are defined elsewhere
      dark: yellowDark
    },
    error: {
      light: red,
      dark: redDark
    },
    // Optional: Use your brand color for the success state as well
    success: {
      light: accentLight,
      dark: accentDark
    }
  }
});
const modifiedThemes = {
  ...builtThemes,
  // Override the base light theme
  light: {
    ...builtThemes.light
    //...lightOverrides,
  }
  // Optional: If you use sub-themes like light_Button, 
  // they inherit from 'light' automatically unless you override them too.
};
const themes = modifiedThemes;
export { themes };
//# sourceMappingURL=themes.mjs.map
